import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AiSuggestionsPlugin } from '../aiSuggestionsPluginType';
import { thinkingPluginKey } from '../pm-plugins/thinking-plugin';
import type { SetReviewingAgentAction } from './types';

/**
 * Publishes the resolved reviewing agent into thinking state. Every surface that
 * shows a loading state reads it from there, so the agent is resolved once per
 * editor rather than once per surface.
 */
export const setReviewingAgentAction =
	(api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined): SetReviewingAgentAction =>
	(agent): boolean =>
		api?.core?.actions.execute(({ tr }) => {
			tr.setMeta(thinkingPluginKey, { reviewingAgent: agent });
			return tr;
		}) || false;
